<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size * 14 / 22"
    viewBox="0 0 22 14"
  >
    <g>
      <g>
        <path
          :fill="color"
          d="M11.18 11.812c-4.14 0-7.724-3.938-8.786-5.225 1.06-1.288 4.638-5.224 8.786-5.224 4.14 0 7.724 3.937 8.786 5.225-1.06 1.288-4.637 5.224-8.786 5.224zm10.205-5.627C21.2 5.933 16.8 0 11.18 0S1.16 5.933.976 6.185a.682.682 0 0 0 0 .805c.185.252 4.585 6.185 10.204 6.185 5.62 0 10.02-5.933 10.205-6.185a.681.681 0 0 0 0-.805z"
        />
      </g>
      <g>
        <path
          :fill="color"
          d="M11.18 9.313a2.729 2.729 0 0 1-2.726-2.726 2.729 2.729 0 0 1 2.726-2.725 2.729 2.729 0 0 1 2.726 2.726 2.729 2.729 0 0 1-2.726 2.725zm0-6.814a4.093 4.093 0 0 0-4.089 4.089 4.093 4.093 0 0 0 4.09 4.088 4.093 4.093 0 0 0 4.088-4.088 4.093 4.093 0 0 0-4.089-4.09z"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#FFF',
    },
    size: {
      type: Number,
      default: 22,
    },
  },
};
</script>
